import React from 'react';
import { debounce } from 'debounce';
import { FormGroup, Input, Label } from 'reactstrap';

class UserCredential extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            email: '',
            password: '',
            confirmedPassword: '',
        };
    }

    handleOnChange = (event) => {
        const { target: { name, value } } = event;
        this.setState({ [name]: value }, this.throttleChanges);
    };

    throttleChanges = debounce(() => {
        this.setState({ isValid: this.state.password === this.state.confirmedPassword }, () => this.props.onChange(this.state));
    }, 1000);

    render() {
        return (
            <React.Fragment>
                <FormGroup>
                    <Label>*Email Address:</Label>
                    <Input type='text' name='email' required value={this.state.email} onChange={this.handleOnChange} />
                </FormGroup>
                <FormGroup>
                    <Label>*Password:</Label>
                    <Input type='password' name='password' required value={this.state.password} onChange={this.handleOnChange} />
                </FormGroup>
                <FormGroup>
                    <Label>*Confirm Password:</Label>
                    <Input type='password' name='confirmedPassword' required value={this.state.confirmedPassword} onChange={this.handleOnChange} />
                </FormGroup>
            </React.Fragment>
        );
    }
}

export default UserCredential;